import { goesLoadingPathsA } from "./goes-loading-paths-a";
import { goesLoadingPathsB } from "./goes-loading-paths-b";

export const goesLoadingPaths = (
  <>
    {goesLoadingPathsA}
    {goesLoadingPathsB}
  </>
);
